var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1258_3749)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1258_3749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5C9.31371 12.5 12 9.81371 12 6.5C12 3.18629 9.31371 0.5 6 0.5C2.68629 0.5 0 3.18629 0 6.5C0 9.81371 2.68629 12.5 6 12.5Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0928 2.23438L6.03561 2.42984V8.09891L6.0928 8.15609L8.72436 6.60078L6.0928 2.23438Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09281 2.23438L3.46124 6.60078L6.09281 8.15609V5.40453V2.23438Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0928 8.65438L6.06046 8.69422V10.7136L6.0928 10.8083L8.72624 7.10001L6.0928 8.65438Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09281 10.8083V8.65436L3.46124 7.09952L6.09281 10.8083Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0928 8.1561L8.72437 6.60079L6.0928 5.40454V8.1561Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.46124 6.60079L6.09281 8.1561V5.40454L3.46124 6.60079Z",
    fill: "#393939"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1258_3749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1258_3749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.c8422176e78c6c805f664f516bf8f6b4.svg";
export { ForwardRef as ReactComponent };